export const jeddahFallbackData = [
  {
    "id": 2435,
    "table_key": "jeddah_airport_profile",
    "title": "Jeddah Airport Profile",
    "data": {
      "car_park_bays": {
        "label": "Jeddah Airport Car Park Bays",
        "value": "12,442"
      },
      "contract_term": {
        "label": "Contract Term",
        "value": "4 years & 7 months;    "
      },
      "contract_period": {
        "start_date": "06/01/2021",
        "end_date": "31/07/2025"
      },
      "operational_hours": {
        "label": "Operational Hours",
        "value": "24 Hours Per Day"
      },
      "vat_note": {
        "value": "Parking charges are excluding of VAT 15%"
      }
    },
    "updated_at": "24-FEB-26 03.32.48.370341 PM"
  },
  {
    "id": 2436,
    "table_key": "jeddah_airport_parking_bays_breakdown",
    "title": "Jeddah Airport Parking Bays",
    "data": {
      "columns": [
        "JEDDAH AIRPORT PARKING BAYS",
        "12,442"
      ],
      "rows": [
        [
          "Employee Car Park",
          "1,089"
        ],
        [
          "MSCP Car Park",
          "5,964"
        ],
        [
          "Rental Car Park",
          "1,091"
        ],
        [
          "First & Business Class Car Park",
          "145"
        ],
        [
          "M AND N Long Term Park",
          "2192"
        ],
        [
          "MSCP Employee Park",
          "1,263"
        ],
        [
          "MSCP Car Pound",
          "50"
        ],
        [
          "JAP - BP",
          "48"
        ],
        [
          "JAP - RO",
          "600"
        ]
      ]
    },
    "updated_at": "24-FEB-26 03.32.48.375128 PM"
  },
  {
    "id": 2437,
    "table_key": "jeddah_airport_parking_rates",
    "title": "Parking Rates (Excluding VAT 15%)",
    "data": {
      "columns": [
        {
          "column_key": "location",
          "label": "LOCATION",
          "type": "text"
        },
        {
          "column_key": "rates",
          "label": "RATES",
          "type": "group",
          "sub_columns": [
            {
              "column_key": "pay_at_exit",
              "label": "Pay at Exit",
              "type": "text"
            },
            {
              "column_key": "pay_at_apm",
              "label": "Pay at APM",
              "type": "text"
            }
          ]
        },
        {
          "column_key": "grace_period",
          "label": "Grace Period After Payment",
          "type": "text"
        }
      ],
      "rows": [
        {
          "location": "Multi Story Car Park",
          "rates": {
            "pay_at_exit": "SAR 10 per hour",
            "pay_at_apm": "SAR 5 per hour"
          },
          "grace_period": "15 mins"
        },
        {
          "location": "1st Class & Business Class",
          "rates": {
            "pay_at_exit": "SAR 30 per hour",
            "pay_at_apm": "SAR 20 per hour"
          },
          "grace_period": "15 mins"
        },
        {
          "location": "Long Term (M&N)",
          "rates": {
            "pay_at_exit": "SAR 03 per hour (First 24 hrs), SAR 02 per hour (After 24 hrs)",
            "pay_at_apm": "No APM"
          },
          "grace_period": "15 mins"
        }
      ]
    },
    "updated_at": "24-FEB-26 03.32.48.379852 PM"
  },
  {
    "id": 2438,
    "table_key": "jeddah_airport_membership_charges",
    "title": "Membership Charges (Excluding VAT 15%)",
    "data": {
      "columns": [
        "Location",
        "Government Employee",
        "Commercial Employee"
      ],
      "rows": [
        [
          "Multi Story Car Park",
          "SAR 150 per month",
          "SAR 350 per month"
        ],
        [
          "1st Class & Business Class",
          "SAR 350 per month",
          "SAR 600 per month"
        ],
        [
          "Staff Surface Parking Area",
          "Free",
          "SAR 150 per month"
        ]
      ]
    },
    "updated_at": "24-FEB-26 03.32.48.383571 PM"
  },
  {
    "id": 2439,
    "table_key": "jeddah_airport_assets_deployed",
    "title": "Jeddah Airport",
    "data": {
      "groups": [
        {
          "group_name": "Ticket Dispenser",
          "group_total_qty": "21",
          "items": [
            {
              "item_name": "DIP G100",
              "qty": "6"
            },
            {
              "item_name": "G100 64 Bit",
              "qty": "15"
            },
            {
              "item_name": "G100 32 Bit",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Ticket Verifier",
          "group_total_qty": "33",
          "items": [
            {
              "item_name": "EV DIP G100",
              "qty": "24"
            },
            {
              "item_name": "EV G100 64 Bit",
              "qty": "9"
            },
            {
              "item_name": "EV G100 32 Bit",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "APM's",
          "group_total_qty": "13",
          "items": [
            {
              "item_name": "APM ETS-70",
              "qty": "13"
            },
            {
              "item_name": "APM ETS-100",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "PIN Pad",
          "group_total_qty": "31",
          "items": [
            {
              "item_name": "IUP250",
              "qty": "31"
            }
          ]
        },
        {
          "group_name": "Card Reader",
          "group_total_qty": "13",
          "items": [
            {
              "item_name": "IUR250",
              "qty": "13"
            }
          ]
        },
        {
          "group_name": "B-Contactless",
          "group_total_qty": "31",
          "items": [
            {
              "item_name": "IUC150",
              "qty": "31"
            }
          ]
        },
        {
          "group_name": "RFID Reader",
          "group_total_qty": "51",
          "items": []
        },
        {
          "group_name": "IP Barrier",
          "group_total_qty": "56",
          "items": []
        },
        {
          "group_name": "ANPR Camera",
          "group_total_qty": "54",
          "items": [
            {
              "item_name": "ARH",
              "qty": "54"
            },
            {
              "item_name": "Lumenera",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Sliding Gate",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "RIGHT",
              "qty": "-"
            },
            {
              "item_name": "LEFT",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "PND's",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "TPAL BNA-Large",
              "qty": "-"
            },
            {
              "item_name": "T-PAL TX",
              "qty": "-"
            },
            {
              "item_name": "T-PAL V2",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Pound Cashier Device",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "CN-50",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Driver Device",
          "group_total_qty": "7",
          "items": [
            {
              "item_name": "CN-51",
              "qty": "7"
            }
          ]
        },
        {
          "group_name": "Enf Device",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "Oukitel WP2",
              "qty": "-"
            },
            {
              "item_name": "Doogee V10",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Validation",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "Lenova Tablet",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Printer",
          "group_total_qty": "7",
          "items": [
            {
              "item_name": "PR-3",
              "qty": "7"
            },
            {
              "item_name": "SEWOO",
              "qty": "-"
            },
            {
              "item_name": "BIXOLON",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Tow Truck",
          "group_total_qty": "7",
          "items": []
        },
        {
          "group_name": "Clamp Vehicle",
          "group_total_qty": "-",
          "items": []
        },
        {
          "group_name": "Support Vehicle",
          "group_total_qty": "2",
          "items": []
        }
      ]
    },
    "updated_at": "24-FEB-26 03.32.48.387345 PM"
  },


  {
    "id": 2945,
    "table_key": "jeddah_airport_enforcement_profile_summary",
    "title": "Jeddah Airport Enforcement Profile ",
    "data": {
      "profile_name": "Jeddah Airport Enforcement Profile",
      "section": "Assets Deployed"
    },
    "updated_at": "23-FEB-26 04.56.02.592625 PM"
  },
  {
    "id": 2946,
    "table_key": "violations_table_fees",
    "title": "Violations Table & Fees",
    "data": {
      "columns": [
        "#",
        "english",
        "code",
        "escalation",
        "amount",
        "arabic",
        "#"
      ],
      "rows": [
  [
    1,
    "Not parked within marking space",
    13,
    "CN / TOW",
    350,
    "عدم الوقوف بشكل صحيح ضمن حيز الوقوف",
    1
  ],
  [
    2,
    "Parked/overstayed in a loading/unloading space",
    14,
    "CN / TOW",
    350,
    "الوقوف في مكان مخصص لتحميل والتفريغ بدون تصريح",
    2

  ],
  [
    3,
    "Parked in a space for Special Needs without a valid permit",
    15,
    "CN / TOW",
    500,
    "الوقوف في مكان مخصص لذوي الاحتياجات الخاصة بدون تصريح",3
  ],
  [
    4,
    "Parked without at least one license plate",
    16,
    "CN / Clamp",
    150,
    "الوقوف بدون لوحة واحدة على الأقل في حيز الوقوف",4
  ],
  [
    5,
    "Parked within the road and traffic area",
    800,
    "CN / TOW",
    350,
    "الوقوف ضمن حرم الطريق ومرور السيارات",5
  ],
  [
    6,
    "Parked in a non-parking area",
    801,
    "CN / TOW",
    350,
    "الوقوف ضمن منطقة ممنوع الوقوف فيها",6
  ],
  [
    7,
    "Parked on pedestrian or buildings' entries",
    802,
    "CN / TOW",
    350,
    "الوقوف على مداخل المشاة أو المباني",7
  ],
  [
    8,
    "Parked on the pavement or on a pedestrian area",
    803,
    "CN / TOW",
    350,
    "الوقوف على الرصيف أو في منطقة المشاة",8
  ],
  [
    9,
    "Parked facing the opposite direction of traffic flow",
    804,
    "CN",
    350,
    "الوقوف بشكل معاكس لاتجاه السير",9
  ],
  [
    10,
    "Parked in an officially reserved space",
    805,
    "CN / TOW",
    350,
    "الوقوف في مكان تم حجزه رسميا",10
  ],
  [
    11,
    "Parked in a suspended space (temporary out of use)",
    806,
    "CN / TOW",
    350,
    "الوقوف في حيز معلق الاستخدام",11
  ],
  [
    12,
    "Parked outside allowed time",
    809,
    "CN / TOW",
    350,
    "تجاوز الحد الأقصى المسموح به للوقوف",12
  ],
  [
    13,
    "Parked in violation of posted signs",
    810,
    "CN / TOW",
    350,
    "الوقوف بشكل مخالف للوحات الإرشادية",13
  ],
  [
    14,
    "Parked on a fire hydrant bay",
    811,
    "CN / TOW",
    350,
    "الوقوف إلى جانب طفايات الحريق بمسافة تقل عن 3 متر",14
  ],
  [
    15,
    "Park in Sand Areas",
    21,
    "CN / TOW",
    350,
    "الوقوف في منطقة رملية",15
  ],
  [
    16,
    "Washing / Cleaning Vehicles inside the parking area",
    null,
    "CN",
    100,
    "غسيل وتنظيف المركبات داخل المواقف",16
  ],
  [
    17,
    "Entering / Exiting the Parking in a wrong way",
    null,
    "CN / TOW",
    1000,
    "الدخول والخروج من المواقف بطريقة غير نظامية",17
  ],
  [
    null,
    "NOTES :",
    null,
    null,
    null,
    "ملاحظة :",
    
  ],
  [
    18,
    "Tow Charge",
    null,
    "",
    200,
    "أجرة السحب",18
  ],
  [
    19,
    "Clamp Charge",
    null,
    "",
    200,
    "قفل العجلة",19
  ],
  [
    20,
    "Storage: 120/day (start when the violated vehicle enters the Pound)",
    null,
    "",
    120,
    "حجز الوظيفة: 120 يوم (تبدأ عند دخول المركبة المخالفة لمنطقة إيواء المركبات)",20
  ],
  [
    21,
    "Vehicle Towing Service",
    null,
    "",
    200,
    "خدمة سحب المركبة",21
  ]
],
    },
    "updated_at": "23-FEB-26 04.56.02.599396 PM"
  },
  {
    "id": 2948,
    "table_key": "assets_deployed_enforcement",
    "title": "Jeddah Airport Enforcement - Assets Deployed",
    "data": {
      "groups": [
        {
          "group": "Ticket Dispenser",
          "items": [
            {
              "name": "DIP G100",
              "qty": "-"
            },
            {
              "name": "G100 64 Bit",
              "qty": "-"
            },
            {
              "name": "G100 32 Bit",
              "qty": "-"
            }
          ]
        },
        {
          "group": "Ticket Verifier",
          "items": [
            {
              "name": "EV DIP G100",
              "qty": "-"
            },
            {
              "name": "EV G100 64 Bit",
              "qty": "-"
            },
            {
              "name": "EV G100 32 Bit",
              "qty": "-"
            }
          ]
        },
        {
          "group": "APM's",
          "items": [
            {
              "name": "APM ETS-70",
              "qty": "-"
            },
            {
              "name": "APM ETS-100",
              "qty": "-"
            }
          ]
        },
        {
          "group": "PIN Pad",
          "items": [
            {
              "name": "IUP250",
              "qty": "-"
            }
          ]
        },
        {
          "group": "Card Reader",
          "items": [
            {
              "name": "IU7250",
              "qty": "-"
            }
          ]
        },
        {
          "group": "B-Contactless",
          "items": [
            {
              "name": "IUC150",
              "qty": "-"
            }
          ]
        },
        {
          "group": "RFID Reader",
          "items": [
            {
              "name": "IP Barrier",
              "qty": "-"
            },
            {
              "name": "ANPR CAMERA",
              "qty": "-"
            },
            {
              "name": "ARH",
              "qty": "-"
            },
            {
              "name": "Lumenera",
              "qty": "-"
            },
            {
              "name": "Sliding Gate",
              "qty": "-"
            },
            {
              "name": "RIGHT",
              "qty": "-"
            },
            {
              "name": "LEFT",
              "qty": "-"
            }
          ]
        },
        {
          "group": "PND's",
          "items": [
            {
              "name": "TPAL - BNA Large",
              "qty": "-"
            },
            {
              "name": "T-PAL TX",
              "qty": "-"
            },
            {
              "name": "T-PAL V2",
              "qty": "-"
            },
            {
              "name": "Pound Cahier Device",
              "qty": "-"
            }
          ]
        },
        {
          "group": "Driver Device",
          "items": [
            {
              "name": "CN-51",
              "qty": 7
            }
          ],
          "total": 7
        },
        {
          "group": "End Device",
          "items": [
            {
              "name": "Quicktel WP2",
              "qty": "-"
            },
            {
              "name": "Doogee V10",
              "qty": "-"
            },
            {
              "name": "Validation",
              "qty": "-"
            },
            {
              "name": "Lenovo Tablet",
              "qty": "-"
            }
          ]
        },
        {
          "group": "Printer",
          "items": [
            {
              "name": "PR-3",
              "qty": 7
            },
            {
              "name": "SEWOO",
              "qty": "-"
            },
            {
              "name": "BIXOLON",
              "qty": "-"
            }
          ],
          "total": 7
        },
       {
          "group": "Tow Truck",
          "total": "7",
          "items": []
        },
        {
          "group": "Clamp Vehicle",
          "total": "-",
          "items": []
        },
        {
          "group": "Support Vehicle",
          "total": "-",
          "items": []
        }
      ]
    },
    "updated_at": "23-FEB-26 04.56.02.606404 PM"
  },

  {
    "id": 3176,
    "table_key": "jeddah_airport_parking_assets_deployed",
    "title": "Jeddah Airport Parking",
    "data": {
      "groups": [
        {
          "group_name": "Ticket Dispenser",
          "group_total_qty": 21,
          "items": [
            {
              "item_name": "DIP G100",
              "qty": 6
            },
            {
              "item_name": "G100 64 Bit",
              "qty": 15
            },
            {
              "item_name": "G100 32 Bit",
              "qty": 0
            }
          ]
        },
        {
          "group_name": "Ticket Verifier",
          "group_total_qty": 33,
          "items": [
            {
              "item_name": "EV DIP G100",
              "qty": 24
            },
            {
              "item_name": "EV G100 64 Bit",
              "qty": 9
            },
            {
              "item_name": "EV G100 32 Bit",
              "qty": 0
            }
          ]
        },
        {
          "group_name": "APM's",
          "group_total_qty": 13,
          "items": [
            {
              "item_name": "APM ETS-70",
              "qty": 13
            },
            {
              "item_name": "APM ETS-100",
              "qty": 0
            }
          ]
        },
        {
          "group_name": "PIN Pad",
          "group_total_qty": 31,
          "items": [
            {
              "item_name": "IUP250",
              "qty": 31
            }
          ]
        },
        {
          "group_name": "Card Reader",
          "group_total_qty": 13,
          "items": [
            {
              "item_name": "IUR250",
              "qty": 13
            }
          ]
        },
        {
          "group_name": "B-Contactless",
          "group_total_qty": 31,
          "items": [
            {
              "item_name": "IUC150",
              "qty": 31
            }
          ]
        },
        {
          "group_name": "RFID Reader",
          "group_total_qty": 51,
          "items": []
        },
        {
          "group_name": "IP Barrier",
          "group_total_qty": 56,
          "items": []
        },
        {
          "group_name": "ANPR Camera",
          "group_total_qty": 54,
          "items": [
            {
              "item_name": "ARH",
              "qty": 54
            },
            {
              "item_name": "Lumenera",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Sliding Gate",
          "group_total_qty": "-",           
          "items": [
            {
              "item_name": "RIGHT",
              "qty": "-"
            },
            {
              "item_name": "LEFT",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "PND's",
          "group_total_qty": "0",
          "items": [
            {
              "item_name": "TPAL BNA-Large",
              "qty": "-"
            },
            {
              "item_name": "T-PAL TX",
              "qty": "-"
            },
            {
              "item_name": "T-PAL V2",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Pound Cashier Device",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "CN-50",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Driver Device",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "CN-51",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Enf Device",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "Oukitel WP2",
              "qty": "-"
            },
            {
              "item_name": "Doogee V10",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Validation",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "Lenova Tablet",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Printer",
          "group_total_qty": "-",
          "items": [
            {
              "item_name": "PR-3",
              "qty": "-"
            },
            {
              "item_name": "SEWOO",
              "qty": "-"
            },
            {
              "item_name": "BIXOLON",
              "qty": "-"
            }
          ]
        },
        {
          "group_name": "Tow Truck",
          "group_total_qty": "-",
          "items": []
        },
        {
          "group_name": "Clamp Vehicle",
          "group_total_qty": "-",
          "items": []
        },
        {
          "group_name": "Support Vehicle",
          "group_total_qty": 2,
          "items": []
        }
      ]
    },
    "updated_at": "24-FEB-26 03.25.15.549483 PM"
  }
]